export default {
    state: {
        customers: {}, // {id: 123, company_id: 123, name:""}
        myOrders: [],
        pendingOrders: [],
        userCustomers: [],// {customer_id: 123, orders: []}
    },
    getters: {

    },
    mutations: {
        clearDashboard(state) {
            state.customers = {};
            state.myOrders = [];
            state.pendingOrders = [];
            state.userCustomers = [];
        },
        setMyOrders(state, orders) {
            state.myOrders = orders;
        },
        setPendingOrders(state, orders) {
            state.pendingOrders = orders;
        },
        setCustomerOrders(state, customer) {
            state.userCustomers = customer;
        },
        addCustomerOrder(state, customerData) {
            state.userCustomers.push(customerData);
        },
        setCustomers(state, customerData) {
            state.customers = customerData;
            console.log('Setting Customers', customerData);
        }
    },
    actions: {
        getCustomersForUser(context) {
            var customerRoles = this._vm.$auth.user().customer_roles;
            if (!customerRoles || !customerRoles.length) {
                context.commit('setCustomerOrders', [])
                return;
            }
            context.commit('setCustomerOrders', []);

            let customers = {};
            for (let i = 0; i < customerRoles.length; i++) {
                customers[customerRoles[i].customer_id] = customerRoles[i].customer;

                let customerId = customerRoles[0].customer_id;
                context.dispatch('getOrdersForCustomer', customerId)
                    .then((response) => {
                        context.commit('addCustomerOrder', {customer_id: customerId, orders: response.data})
                    });
            }
            context.commit('setCustomers', customers);
        },
        getOrdersForUser(context) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get(`/dashboard/orders`)
                    .then((response) => {

                        context.commit('setMyOrders', response.data.orders);
                        context.commit('setPendingOrders', response.data.pending);
                        resolve(response);
                    })
                    .catch(reject);
            });
        },
        getOrdersForCustomer(context, customerId) {

            return new Promise((resolve, reject) => {
                this._vm.axios.get('/dashboard/orders/customer/' + customerId)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch(reject);
            });
        },
    }
}